module.exports = ".logo-small img {\r\n    width: 50px;\r\n    margin-right: 10px;\r\n}\r\n.logo-txt {\r\n    font-size: 20px;\r\n}"